import { Record } from 'immutable';
import VehicleModelV25 from 'commons-vehicle/Vehicle/models/VehicleModelV25';
import QuoteModelV25 from 'commons-vehicle/Quote/models/QuoteModelV25.js';
import { pick } from 'lodash';

const SaveNewQuoteModel = Record({
    leadId: 0,
    accountId: 0,
    year: 0,
    make: '',
    model: '',
    vehicleCondition: '',
    modelTrimCode: '',
    configurationId: 0,
    showroomVehicleId: '',
    vehicleId: 0,
    vin: '',
    stockNumber: '',
    saleType: 'retail',
    taxPlan: 'standard',
    odometer: 0,
    purchaseMethod: 'cash',
    financePlan: '',
    kmPerYearPlan: 0,
    paymentFrequency: 12,
    term: 0,
    cashDown: 0,
    tradeIn: 0,
    lien: 0,
    transactionTokenCopy: '',
    transactionToken: '',
    sellingPrice: 0,
    retail: 0,
});

class SaveNewQuoteModelV25 extends SaveNewQuoteModel {
    constructor(modelDefaults) {
        if (modelDefaults) {
            super(modelDefaults);
        } else {
            super();
        }
    }

    setModelValuesFromQuoteModelV25(quoteModelV25) {
        if (!(Object.getPrototypeOf(quoteModelV25) === Object.getPrototypeOf(new QuoteModelV25()))) {
            throw new Error('setModelValuesFromQuoteModelV25 expecting instance of QuoteModelV25');
        }

        return this.setModelValuesFromVehicleModelV25(quoteModelV25.vehicle)
            .set('accountId', quoteModelV25.accountId)
            .set('leadId', quoteModelV25.leadId);
    }

    setModelValuesFromVehicleModelV25(vehicleModelV25) {
        if (!(Object.getPrototypeOf(vehicleModelV25) === Object.getPrototypeOf(new VehicleModelV25()))) {
            throw new Error('setModelValuesFromVehicleModelV25 expecting instance of VehicleModelV25');
        }

        const keys = Object.keys(this.toObject());
        const toMerge = pick(vehicleModelV25.toObject(), keys);

        return this.merge({
            ...toMerge,
            make: vehicleModelV25.getMake(),
            model: vehicleModelV25.getModel(),
            saleType: vehicleModelV25.purchaseMethods.saleType,
            taxPlan: vehicleModelV25.purchaseMethods.taxPlan,
            purchaseMethod: vehicleModelV25.purchaseMethods.purchaseMethod,
            financePlan: vehicleModelV25.purchaseMethods.financePlan,
            kmPerYearPlan: vehicleModelV25.purchaseMethods.kmPerYearPlan,
            paymentFrequency: vehicleModelV25.purchaseMethods.paymentFrequency,
            term: vehicleModelV25.purchaseMethods.term,
            cashDown: vehicleModelV25.purchaseMethods.cashDown,
            tradeIn: vehicleModelV25.purchaseMethods.tradeIn,
            lien: vehicleModelV25.purchaseMethods.lien,
            transactionTokenCopy: vehicleModelV25.purchaseMethods.transactionToken,
            transactionToken: vehicleModelV25.purchaseMethods.transactionToken,
            sellingPrice: vehicleModelV25.purchaseMethods?.sellingPrice || 0,
            retail: vehicleModelV25.purchaseMethods?.retailDetails?.total || 0,
        });
    }
}

export default SaveNewQuoteModelV25;
